import { ORG } from "../../site/config";
import type { BusinessCopy } from "../types";

export const BUSINESS_PT_BR: BusinessCopy = {
  home: "Início",
  breadcrumb: "Para sua empresa",
  breadcrumbLabel: "Você está em",
  sectionNavLabel: "Nesta página",
  sectionNav: [
    { label: "Serviços", href: "#servicos" },
    { label: "PWA", href: "#pwa" },
    { label: "Distribute", href: "#distribute" },
    { label: "Jobxtech", href: "#jobxtech" },
    { label: "Perguntas", href: "#perguntas" },
    { label: "Contato", href: "#contato" },
  ],
  hero: {
    heading: "Tecnologia sob medida para a sua empresa",
    lead: "Desenvolvemos apps e sistemas sob medida, com foco em apps web progressivos (PWAs) que funcionam em qualquer aparelho. E estamos abrindo para outras empresas as ferramentas que usamos nos nossos próprios produtos.",
    primaryCta: { label: "Agendar consulta gratuita", href: "#contato" },
    secondaryCta: { label: "Ver serviços", href: "#servicos" },
    stats: [
      { value: "9+", label: "Clientes atendidos" },
      { value: "Gratuita", label: "Consulta inicial" },
    ],
  },
  services: {
    heading: "Serviços sob medida",
    lead: "Do primeiro esboço ao app publicado. Temos capacidade limitada para novos projetos, para dar atenção de verdade a cada cliente.",
    offers: [
      {
        title: "Consulta inicial",
        badge: "Gratuita",
        description:
          "Uma conversa para entender o seu projeto e indicar o melhor caminho.",
        includes: [
          "Análise de requisitos",
          "Recomendação de tecnologia",
          "Estimativa inicial",
        ],
        cta: { label: "Solicitar consulta", href: "#contato" },
      },
      {
        title: "Desenvolvimento sob medida",
        description:
          "Desenvolvimento completo do seu app ou sistema, conforme as necessidades da sua empresa.",
        includes: [
          "Escopo personalizado",
          "Cronograma sob medida",
          "Suporte dedicado",
        ],
        cta: { label: "Solicitar proposta", href: "#contato" },
      },
    ],
    processTitle: "Como funciona",
    process: [
      "Consulta inicial gratuita para entender o projeto",
      "Proposta com escopo, cronograma e investimento",
      "Desenvolvimento e entrega",
    ],
  },
  pwa: {
    heading: "Apps que funcionam sem download",
    lead: "Desenvolvemos apps web progressivos (PWAs): o app abre no navegador, pode ser instalado na tela inicial e funciona como um app nativo.",
    cards: [
      {
        title: "Instaláveis",
        description:
          "Instalação direto do navegador, sem passar por uma loja de aplicativos.",
        benefits: [
          "Instalação direta",
          "Funciona offline",
          "Atualizações automáticas",
          "Arquivos menores",
        ],
      },
      {
        title: "Multiplataforma",
        description: "Uma única solução para Android, iOS e web.",
        benefits: [
          "Desenvolvimento mais rápido",
          "Manutenção simplificada",
          "Experiência consistente",
          "Custo menor",
        ],
      },
      {
        title: "Rápidos",
        description:
          "Otimizados para carregar rápido, mesmo em conexões lentas.",
        benefits: [
          "Carregamento rápido",
          "Funciona em conexões lentas",
          "Navegação fluida",
          "Bom para SEO",
        ],
      },
    ],
  },
  distribute: {
    heading: "Codecious Distribute",
    badge: "Acesso antecipado",
    lead: "A plataforma de marketing digital com IA que usamos para divulgar os nossos próprios apps. Estamos preparando o acesso para outras empresas.",
    featuresTitle: "O que ela já faz",
    features: [
      "Campanhas do Google Ads e do Meta Ads em um só painel, com métricas diárias",
      "Textos de anúncio gerados com IA, organizados em uma biblioteca",
      "Imagens para anúncios criadas com IA",
    ],
    waitlistTitle: "Quer acesso antecipado?",
    waitlistText:
      "Entre na lista e avisamos por e-mail quando abrirmos o acesso para a sua empresa.",
  },
  jobxtech: {
    heading: "Jobxtech para empresas",
    badge: "Em breve",
    lead: "Plataforma para publicar vagas de tecnologia e encontrar profissionais da área. Está em desenvolvimento.",
    waitlistTitle: "Quer usar o Jobxtech na sua empresa?",
    waitlistText:
      "Entre na lista e avisamos por e-mail quando o Jobxtech for lançado.",
    note: {
      text: "Procura vagas em tecnologia?",
      linkLabel: "Veja o Jobxtech para profissionais",
      href: "/apps/jobxtech",
    },
  },
  faq: {
    heading: "Perguntas frequentes",
    items: [
      {
        question: "A Codecious desenvolve apps para outras empresas?",
        answer:
          "Sim. Além dos nossos produtos próprios, desenvolvemos apps e sistemas sob medida. O processo começa com uma consulta inicial gratuita para entender o projeto, seguida de uma proposta com escopo, cronograma e investimento.",
      },
      {
        question: "A consulta inicial é gratuita?",
        answer:
          "Sim. Na consulta analisamos os requisitos do projeto, recomendamos a tecnologia e fazemos uma estimativa inicial, sem custo.",
      },
      {
        question: "O que é um PWA?",
        answer:
          "PWA (Progressive Web App) é um app que abre no navegador e pode ser instalado na tela inicial do aparelho, sem passar por uma loja de aplicativos. Ele funciona offline e recebe atualizações automáticas.",
      },
      {
        question: "Quais plataformas são atendidas?",
        answer:
          "Um PWA funciona em Android, iOS, Windows, macOS e Linux, em qualquer navegador moderno. Quando o projeto pede, também publicamos o app nas lojas, como fizemos com o Gymtero no Google Play.",
      },
      {
        question: "O que é o Codecious Distribute?",
        answer:
          "É a plataforma de marketing digital com IA que usamos nos nossos apps: reúne as campanhas do Google Ads e do Meta Ads e ajuda a criar textos e imagens para anúncios. O acesso para outras empresas está em preparação; entre na lista de espera para ser avisado.",
      },
      {
        question: "Como entro em contato?",
        answer: `Pelo formulário desta página, pelo e-mail ${ORG.email} ou pelo WhatsApp ${ORG.whatsapp.display}.`,
      },
    ],
  },
  contact: {
    heading: "Fale com a gente",
    lead: "Conte um pouco sobre o seu projeto. Respondemos por e-mail.",
  },
};
